<template>
  <video-bg v-if="video_source" :sources="[mobile_view?video_source_mobile:video_source]">
    <Header @refresh="refresh" />
    <!-- <div class="video_content">
      <transition name="fade" v-if="alert_msg">
        <div class="video_content_text" v-html="alert_msg" />
      </transition>
    </div>-->
  </video-bg>
  <Header v-else @refresh="refresh" />
</template>

<script>
import Header from "../components/Header.vue";
import VideoBg from "vue-videobg";
import _ from "lodash";

export default {
  name: "HeaderWithVideo",
  components: {
    Header,
    VideoBg
  },
  data: function() {
    var video_source = localStorage.getItem("video_source");
    var video_source_mobile = localStorage.getItem("video_source_mobile");
    return {
      mobile_view: false,
      video_source: _.isEmpty(video_source) ? null : video_source,
      video_source_mobile: _.isEmpty(video_source_mobile)
        ? null
        : video_source_mobile
    };
  },
  methods: {
    onResize() {
      if (document.documentElement.clientWidth > 480) {
        this.mobile_view = false;
      } else {
        this.mobile_view = true;
      }
    },
    mounted: function() {
      this.onResize();
      window.addEventListener("resize", this.onResize);
      //   setTimeout(() => {
      //     var locale = this.$i18n.locale;
      //     var alert_msg =
      //       locale == "en"
      //         ? localStorage.getItem("alert_msg")
      //         : localStorage.getItem("alert_msg_cht");
      //     if (alert_msg) {
      //       alert_msg = alert_msg.trim();
      //       if (_.isEmpty(alert_msg)) {
      //         alert_msg = null;
      //       } else {
      //         alert_msg =
      //           "<span>" + alert_msg.split("|").join("</span><span>") + "</span>";
      //       }
      //     }
      //     this.alert_msg = alert_msg;
      //   }, 1000);
    },
    refresh() {
      this.$emit("refresh");
    }
  }
};
</script>

<style lang="scss" >
.VideoBg {
  max-height: 1000px;

  @media screen and (max-width: 767px) {
    max-height: none;
  }

  header.main_menu {
    background: rgba(0, 0, 0, 0.5);
    height: 100%;

    #topNav {
      > li {
        position: relative;
        float: left;

        > a {
          padding: 10px 35px;
          color: #fff;
          font-size: 16px;
          line-height: 1;
          font-weight: 500;
          text-transform: uppercase;

          @media (max-width: 1200px) {
            padding-left: 25px;
            padding-right: 25px;
          }

          @media (max-width: 1000px) {
            padding-left: 20px;
            padding-right: 20px;
          }
        }

        a {
          display: block;
          text-decoration: none;
        }

        ul {
          position: absolute;
          top: 100%;
          min-width: 235px;
          background: rgba(16, 16, 21, 0.6);
          z-index: 1039;
          list-style-type: none;
          padding: 0;
          opacity: 0;
          transition: all 0.8s cubic-bezier(0.65, 0.05, 0.36, 1);
          opacity: 0;

          > li {
            position: relative;
            opacity: 0;
            -webkit-transition: all 0.8s ease-in-out;
            -moz-transition: all 0.8s ease-in-out;
            transition: all 0.8s ease-in-out;
            display: none;
            border-top: 1px solid transparent;

            > a {
              font-size: 16px;
              padding: 11px 31px;
              color: #ffffff;
              background: rgba(16, 16, 21, 0.6);
              white-space: nowrap;
            }

            > a:hover {
              color: #f3c606;
            }
          }
        }
      }

      > li.active,
      > li:hover {
        a {
          color: #fff;
          background: rgba(16, 16, 21, 0.6);
        }

        ul {
          position: absolute;
          opacity: 1;

          li {
            opacity: 1 !important;
            display: block;
          }
        }
      }
    }
  }

  .video_content {
    position: absolute;
    top: 60%;
    left: 0;
    right: 0;
    bottom: 0;
    color: #ffff;
    font-weight: 400;
    letter-spacing: 0px;
    font-style: normal;
    font-size: 40px;
    line-height: 1.4;
    padding: 0 30px;
    max-width: 768px;
    margin: auto;
    margin-top: -120px;
    font-family: "PT Serif", sans-serif, arial;
    opacity: 0.9;

    @media screen and (max-width: 767px) {
      font-size: 30px;
      line-height: 1.2;
    }
  }
}
</style>